<!-- 批阅试卷页面 -->
<template>
    <div class="exam-detail yx-start" v-loading="loading">
        <div class="cards app-width auto-grow" v-if="currentPaper!==null">
            <div class="answer-card yx-start no-shrink">
                <!--考生信息-->
                <div class="user-info yx-start font-size16">
                    <div class="title c-32353A font-medium">考生信息</div>
                    <div class="info-item"><label>账号：</label>
                        {{currentPaper.UserName}}
                    </div>
                    <div class="info-item"><label>用户组：</label>
                        {{currentPaper.UserOrganName || "无"}}
                    </div>
                </div>
                <div class="achievement yx-start font-size16">
                    <div class="title c-32353A font-medium">考试成绩</div>
                    <div class="xy-center ball">
                        <div class="in-ball"></div>
                        <div class="score"><span>{{round(totalScore, 2)}}</span>分</div>
                    </div>
                </div>
                <!--答题卡标题-->
                <div class="card-title full-width font-size14">
                    <div class="title c-32353A font-medium">答题卡</div>
                    <div class="xy-center ans-color">
                        <div><span style="background: #256CF4"></span>已批阅</div>
                        <div><span style="background: #FFFFFF;border: 1px solid #E5E8EC;"></span>未批阅</div>
                    </div>
                </div>
                <div class="ans-list auto-grow" v-mousewheel="handleMouseWheel">
                    <div v-for="(spin, index) in dataList" :key="index">
                        <div class="snap-title font-size16">{{ toChinesNum(index + 1) }}、{{ spin.Content }}</div>
                        <div class="ans-grid">
                            <div v-for="(orginObj,index2) in spin.ExamPaperSubjectData" :key="index2"
                                 class="ans-item xy-center cursor" :class="calcAnsClass(orginObj)">
                                <div @click="scrollToQues(orginObj.rankNum)">
                                    {{ orginObj.rankNum }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="submit" v-if="!isHaveSubmit">
                    <button @click="submitAnswer"><i class="iconfont icon-save" style="margin-right: 11px"></i>立即交卷
                    </button>
                </div>
                <!-- 提交试卷后的返回按钮 -->
                <div class="submit submit-back xy-between" v-else>
                    <button @click="goList">
                        {{onlyView?'成绩列表':'批阅列表'}}
                    </button>
                </div>
            </div>
            <div class="paper">
                <div class="xy-center font-size22 font-medium" style="color: #2F3134">
                    {{examName}}
                </div>
                <div class="paper-info font-size14 c-72777F">
                    <div>试卷总分:{{ currentPaper.TotalScore }}分</div>
                    <div>考试时间:{{ currentPaper.ExamTime === 0 ? '不限时长' : currentPaper.ExamTime + '分钟' }}</div>
                    <div>试题总量:{{ currentPaper.SubjectNum }}题</div>
                </div>
                <div class="answer-box">
                    <div v-for="(spin, index) in dataList" :key="index">
                        <div class="spin-title font-size18 font-medium">
                            {{ spin.bigNo }}、{{ spin.Content }}（共{{ spin.SubjectNum }}题，合计{{ spin.SubjectTypeScore }}分）
                        </div>
                        <div v-for="(orginObj,index) in spin.ExamPaperSubjectData" :key="index">
                            <!-- 题干 -->
                            <question :orgin-obj="orginObj">
                                <div class="font-size18 ml-10 no-shrink">
                                    分值：{{orginObj.PerSubjectScore}}分
                                </div>
                            </question>
                            <!-- 单选题 -->
                            <div class="sigleSelect " v-if="orginObj.SubjectType === 1">
                                <div class="topics">
                                    <div class="topicItem jf" v-for="(singleItem,index2) in orginObj.SubjectAnswerData"
                                         :key="index2">
                                        <div class="options xy-center cursor" :class="{'singleActive' : singleItem.rankStyle,
                                             'makeRightStyle' : singleItem.origlRight,
                                             'isErrorActive' : singleItem.userIsErrStyle,
                                             'disabled': isHaveSubmit
                                             }">
                                            {{ opTab[index2] }}
                                        </div>
                                        <div class="content font-size14 cursor"
                                             v-html="singleItem.Content">
                                        </div>
                                    </div>
                                </div>
                                <div class="just-flex mt-60">
                                    <div class="parsingBox auto-grow">
                                        <div class="showAnswerText xy-between">
                                            <div class="lfet jf">
                                                <div class="right jf">
                                                    答案：
                                                    <div class="c-00B37C font-size18"
                                                         v-for="(singleItem,index2) in orginObj.SubjectAnswerData"
                                                         :key="index2">
                                                        <div class="" v-if="singleItem.IsRight">
                                                            <div>{{ opTab[index2] }}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="your jf">
                                                    回答：
                                                    <div v-if="orginObj.UserIsRight" class="c-00B37C font-size18">
                                                        正确
                                                    </div>
                                                    <div v-else-if="orginObj.noAnswer" class="c-F33737 font-size18">
                                                        未作答
                                                    </div>
                                                    <div v-else class="c-F33737 font-size18">
                                                        错误
                                                    </div>
                                                    <!-- <div v-else class="c-F33737 font-size18">正确</div> -->
                                                </div>
                                            </div>
                                            <div class="right">
                                                <!-- 纠错 -->
                                            </div>
                                        </div>
                                        <answer-parser :analysis="orginObj.Analysis"/>
                                    </div>
                                    <give-score v-model="orginObj.Score" :disable="onlyView"
                                        :max-score="orginObj.PerSubjectScore"></give-score>
                                </div>
                            </div>
                            <!-- 多选题 -->
                            <div class="multiSelect " v-else-if="orginObj.SubjectType === 2">
                                <div class="topics">
                                    <div class="topicItem jf" v-for="(singleItem,index2) in orginObj.SubjectAnswerData"
                                         :key="index2">
                                        <div class="options xy-center cursor multiple" :class="{'singleActive' : singleItem.rankStyle,
                                             'makeRightStyle'  : singleItem.origlRight,
                                             'isErrorActive' : singleItem.userIsErrStyle,
                                             'disabled': isHaveSubmit
                                             }">
                                            {{ opTab[index2] }}
                                        </div>
                                        <div class="content font-size14 cursor"
                                             v-html="singleItem.Content"
                                        ></div>
                                    </div>
                                </div>
                                <div class="just-flex mt-60">
                                    <div class="parsingBox auto-grow">
                                        <div class="showAnswerText xy-between">
                                            <div class="lfet jf">
                                                <div class="right jf">
                                                    答案：
                                                    <div class="c-00B37C font-size18"
                                                         v-for="(singleItem,index2) in orginObj.SubjectAnswerData"
                                                         :key="index2">
                                                        <div class="" v-if="singleItem.IsRight">
                                                            <div>{{ opTab[index2] }}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="your jf">
                                                    回答：
                                                    <div v-if="orginObj.UserIsRight" class="c-00B37C font-size18">
                                                        正确
                                                    </div>
                                                    <div v-else-if="orginObj.noAnswer" class="c-F33737 font-size18">
                                                        未作答
                                                    </div>
                                                    <div v-else class="c-F33737 font-size18">
                                                        错误
                                                    </div>
                                                    <!-- <div v-else class="c-F33737 font-size18">正确</div> -->
                                                </div>
                                            </div>
                                            <div class="right">
                                                <!-- 纠错 -->
                                            </div>
                                        </div>
                                        <answer-parser :analysis="orginObj.Analysis"/>
                                    </div>
                                    <give-score v-model="orginObj.Score" :disable="onlyView"
                                                :max-score="orginObj.PerSubjectScore"></give-score>
                                </div>
                            </div>
                            <!-- 填空题 -->
                            <div class="fillBlank" v-else-if="orginObj.SubjectType === 3">
                                <div class="fillBlankItem" v-for="(singleItem,index2) in orginObj.SubjectAnswerData"
                                     :key="index2">
                                    <div class="font-size14 c-333333 fillBlanktext">填空{{ index2 + 1 }}</div>
                                    <div class="fillBlankField" :class="{'disabled': isHaveSubmit}">
                                        <el-input readonly v-model="singleItem.rankStyle" rows="1" autosize
                                                  type="textarea" placeholder="未作答"></el-input>
                                    </div>
                                </div>
                                <div class="just-flex mt-60">
                                    <div class="parsingBox auto-grow">
                                        <div class="showAnswerText xy-between">
                                            <div class="lfet jf">
                                                <div class="right ">
                                                    <div style="margin-bottom:20px;color:#00B37C">正确答案：</div>
                                                    <div v-for="(singleItem,index2) in orginObj.SubjectAnswerData"
                                                         :key="index2">
                                                        <div v-if="singleItem.Content" v-html="singleItem.Content"></div>
                                                        <div v-else>无</div>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="right">
                                                <!-- 纠错 -->
                                            </div>
                                        </div>
                                        <answer-parser :analysis="orginObj.Analysis"/>
                                    </div>
                                    <give-score v-model="orginObj.Score" :disable="onlyView"
                                                :max-score="orginObj.PerSubjectScore"></give-score>
                                </div>
                            </div>
                            <!-- 判断题 -->
                            <div class="judgeTopic" v-else-if="orginObj.SubjectType === 4">
                                <div class="topics">
                                    <div class="topicItem jf" v-for="(singleItem,index2) in orginObj.SubjectAnswerData"
                                         :key="index2">
                                        <div class="options xy-center cursor multiple " :class="{'singleActive' : singleItem.rankStyle,
                                             'makeRightStyle' : singleItem.origlRight,
                                             'isErrorActive' : singleItem.userIsErrStyle,
                                             'disabled': isHaveSubmit
                                        }">
                                            {{ opTab[index2] }}
                                        </div>
                                        <div class="content font-size14 cursor"
                                             v-html="singleItem.Content"
                                        ></div>
                                    </div>
                                </div>
                                <div class="just-flex mt-60">
                                    <div class="parsingBox auto-grow">
                                        <div class="showAnswerText xy-between">
                                            <div class="lfet jf">
                                                <div class="right jf">
                                                    正确答案：
                                                    <div class="c-00B37C font-size18"
                                                         v-for="(singleItem,index2) in orginObj.SubjectAnswerData"
                                                         :key="index2">
                                                        <div class="" v-if="singleItem.IsRight">
                                                            <div>{{ opTab[index2] }}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="your jf">
                                                    您的答案：
                                                    <div class="font-size18"
                                                         :class="[orginObj.UserIsRight ? 'c-00B37C' : 'c-F33737']">
                                                        <div v-if="orginObj.SubjectAnswerData[0].rankStyle">
                                                            <div>{{ opTab[0] }}</div>
                                                        </div>
                                                        <div v-else-if="orginObj.SubjectAnswerData[1].rankStyle">
                                                            <div>{{ opTab[1] }}</div>
                                                        </div>
                                                        <div v-else>
                                                            <div>未作答</div>
                                                        </div>

                                                    </div>
                                                    <!-- <div v-else class="c-F33737 font-size18">正确</div> -->
                                                </div>
                                            </div>
                                            <div class="right">
                                                <!-- 纠错 -->
                                            </div>
                                        </div>
                                        <answer-parser :analysis="orginObj.Analysis"/>
                                    </div>
                                    <give-score v-model="orginObj.Score" :disable="onlyView"
                                                :max-score="orginObj.PerSubjectScore"></give-score>
                                </div>
                            </div>
                            <!-- 简答题 -->
                            <div class="shortAnswer fillBlank" v-else-if="orginObj.SubjectType === 5">
                                <div class="fillBlankItem" v-for="(singleItem,index2) in orginObj.SubjectAnswerData"
                                     :key="index2">
                                    <div class="fillBlankField" style="margin-top: 40px"
                                         :class="{'disabled': isHaveSubmit}">
                                        <el-input readonly v-model="singleItem.rankStyle" rows="1" autosize
                                                  type="textarea" placeholder="未作答"></el-input>
                                    </div>
                                </div>
                                <div class="just-flex mt-60">
                                    <div class="parsingBox auto-grow">
                                        <div class="showAnswerText xy-between">
                                            <div class="lfet jf">
                                                <div class="right ">
                                                    <div style="margin-bottom:20px;color:#00B37C">正确答案：</div>
                                                    <div v-for="(singleItem,index2) in orginObj.SubjectAnswerData"
                                                         :key="index2">
                                                        <div v-if="singleItem.Content" v-html="singleItem.Content"></div>
                                                        <div v-else>无</div>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="right">
                                                <!-- 纠错 -->
                                            </div>
                                        </div>
                                        <answer-parser :analysis="orginObj.Analysis"/>
                                    </div>
                                    <give-score v-model="orginObj.Score" :disable="onlyView"
                                                :max-score="orginObj.PerSubjectScore"></give-score>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="text-center mt-20" v-if="!onlyView">
                        <el-button type="primary" @click="submit">提交批阅结果</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { toChinesNum } from "@/utils";
import scroll from "scroll";
import Question from "@/components/exam/Question";
import AnswerParser from "@/components/exam/AnswerParser";
import GiveScore from "@/components/manager/gradingPaper/GiveScore";
import { GetMarkStudentById, MarkStudentDetail } from "@/api/manage";
import mousewheel from "element-ui/src/directives/mousewheel"
import { round } from "lodash/math";

export default {
    name: "gradingPaper",
    components: { GiveScore, AnswerParser, Question },
    directives: { mousewheel },
    data() {
        return {
            currentPaper: null,
            dataList: [],
            opTab: [],
            isHaveSubmit: true,
            showAnwser: true,
            onlyView: false,
            answerContent: {},
            loading: false
        }
    },
    created() {
        this.loading = true;
        this.GetExamTestInfo().then(() => {
            this.loading = false
        })
        let tabs = [];
        for (let i = 0; i < 24; i++) {
            tabs.push(String.fromCharCode(65 + i))
        }
        this.opTab = tabs;
        this.onlyView = this.$route.query.onlyView === "1"
    },
    computed: {
        examName() {
            return this.$route.query.examName || "未获取到考试名称";
        },
        totalScore() {
            let score = 0
            this.dataList.forEach((spin) => {
                spin.ExamPaperSubjectData.forEach(ques => {
                    if (ques.Score) {
                        score = score + ques.Score
                    }
                })
            })
            return score
        }
    },
    methods: {
        toChinesNum,
        round,
        async GetExamTestInfo() {
            let joinDetailId = this.$route.query.joinDetailId;
            try {
                const data = await GetMarkStudentById({ joinDetailId });
                this.currentPaper = data
                console.log(data, "data");
                this.answerContent = JSON.parse(this.currentPaper.AnswerContent)
                this.addNo(data.SubjectTypeData);
                this.dataList = data.SubjectTypeData
                this.transformAnswer(this.dataList, this.answerContent)
            } catch (err) {
                console.log(err);
                this.$message("服务器繁忙，请稍后再试！");
            }
        },
        // 添加序号
        addNo(dataList) {
            let no = 1;
            for (let i = 0; i < dataList.length; i++) {
                dataList[i].bigNo = toChinesNum(i + 1);
                for (let j = 0; j < dataList[i].ExamPaperSubjectData.length; j++) {
                    dataList[i].ExamPaperSubjectData[j].rankNum = no++
                }
            }
        },
        submitAnswer() {
            console.log("批阅完成")
        },
        goList() {
            this.$router.replace({
                name: this.onlyView ? "exam-results2" : "correct-exam2",
                query: { id: this.$route.query.examId }
            })
        },
        scrollToQues(serial) {
            if (document.scrollingElement == null) return
            let que = document.getElementById("ques-" + serial)
            scroll.top(document.scrollingElement, que.offsetTop)
        },
        // 计算答题卡的class
        calcAnsClass(ques) {
            return {
                "has-ans": ques.Score != null,
            }
        },
        transformAnswer(dataList, answerContent) {
            for (let i = 0; i < dataList.length; i++) {
                for (let j = 0; j < dataList[i].ExamPaperSubjectData.length; j++) {
                    let ques = dataList[i].ExamPaperSubjectData[j]
                    ques.answerContent = answerContent.find(el => el.SubjectId === ques.SubjectId && ((el.subjectTypeId || el.SubjectTypeId) === ques.SubjectTypeId))
                    if (this.onlyView) {
                        if (ques.answerContent) {
                            ques.Score = ques.answerContent.Score
                        } else {
                            ques.Score = 0
                        }
                    }
                    console.log(ques.answerContent, "ques.answerContent");
                    if (ques.SubjectType === 1 || ques.SubjectType === 4) {
                        this.singleQues(ques, ques.answerContent)
                    } else if (ques.SubjectType === 2) {
                        this.multipleQues(ques, ques.answerContent)
                    } else if (ques.SubjectType === 5) {
                        this.shortQues(ques, ques.answerContent)
                    } else if (ques.SubjectType === 3) {
                        this.fillQues(ques, ques.answerContent)
                    }
                }
            }
        },
        // 计算出单选题选中的项,以及是否回答正确
        singleQues(queData, answerContent) {
            if (answerContent == null || answerContent.AnswerContent == null || answerContent.AnswerContent === "") {
                queData.noAnswer = true
                this.$set(queData, "Score", 0)
                return
            }
            console.log(answerContent, "answerContent");
            queData.SubjectAnswerData.some(el => {
                if (el.AnswerId === answerContent.AnswerContent) {
                    el.rankStyle = 1
                    queData.UserIsRight = el.IsRight === 1
                    this.$set(queData, "Score", queData.UserIsRight ? queData.PerSubjectScore : 0)
                    return true
                }
            })
        },
        // 多选题
        multipleQues(queData, answerContent) {
            if (answerContent == null || answerContent.AnswerContent == null || answerContent.AnswerContent === "") {
                queData.noAnswer = true
                this.$set(queData, "Score", 0)
                return
            }
            let ids = answerContent.AnswerContent.split(",")
            let hasErr = false;
            queData.SubjectAnswerData.forEach(el => {
                el.rankStyle = ids.includes(el.AnswerId)
                if (el.rankStyle && !el.IsRight) {
                    hasErr = true; // 选了但这不是正确答案
                }
                if (el.IsRight && !el.rankStyle) {
                    hasErr = true; // 这是正确答案，但是没选
                }
            })
            queData.UserIsRight = !hasErr
            this.$set(queData, "Score", queData.UserIsRight ? queData.PerSubjectScore : 0)
        },
        /// 简答题
        shortQues(queData, answerContent) {
            if (queData.SubjectAnswerData[0] === undefined) {
                queData.SubjectAnswerData.push({ rankStyle: "" })
            }
            if (answerContent === undefined) {
                queData.SubjectAnswerData[0].rankStyle = "未作答"
            } else {
                queData.SubjectAnswerData[0].rankStyle = answerContent.AnswerContent
            }
        },
        // 填空题
        fillQues(queData, answerContent) {
            let ans = []
            if (answerContent && answerContent.AnswerContent) {
                ans = answerContent.AnswerContent.split("[-[-]-]")
            } else {
                queData.SubjectAnswerData.forEach(el => {
                    ans.push(el.AnswerId, "未作答")
                })
            }
            let id = ""
            ans.forEach((val, index) => {
                if (index % 2 === 0 && val === "") return;
                if (index % 2 === 0) {
                    id = val
                } else {
                    queData.SubjectAnswerData.forEach(el => {
                        if (el.AnswerId === id) {
                            el.rankStyle = val || "未作答"
                        }
                    })
                }
            })
        },
        submit() {
            let scoreArr = []
            let noGradingCount = 0
            this.dataList.forEach((spin) => {
                spin.ExamPaperSubjectData.forEach((ques) => {
                    let score = ques.Score || 0
                    console.log(score, "scrore");
                    let obj = {
                        SubjectId: ques.SubjectId,
                        Score: score,
                        IsPass: score > 0,
                        AnswerContent: ques.answerContent?.AnswerContent || "",
                        subjectTypeId: ques.SubjectTypeId
                    }
                    console.log(ques, "ques");
                    scoreArr.push(obj)
                    if (ques.Score === null || ques.Score === undefined) {
                        noGradingCount++
                    }
                })
            })
            this.askNoGrading(noGradingCount).then(() => {
                let data = JSON.stringify(scoreArr)
                this.loading = true
                return MarkStudentDetail({
                    joinDetailId: this.$route.query.joinDetailId,
                    answerContent: data
                })
            }).then(res => {
                this.loading = false
                this.$message.success("提交成功")
                this.goList()
            }).catch(() => {
                this.loading = false
            })
        },
        // 询问是否提交未批阅的题目
        askNoGrading(noGradingCount) {
            if (noGradingCount === 0) {
                return Promise.resolve();
            }
            return this.$confirm(`您还有 ${noGradingCount} 道题未批阅，继续提交系统将按 0 分处理`, "提示", {
                confirmButtonText: "继续",
                cancelButtonText: "取消",
                lockScroll: false,
                type: "warning"
            })
        },
        handleMouseWheel (event) {
            event.stopPropagation()
        }
    },
}
</script>

<style scoped lang="less">
.exam-detail {
    min-height: 100vh;

    .disabled {
        cursor: not-allowed;
    }

    .cards {
        align-items: start;
        display: flex;
        margin-top: 30px;
        position: relative;
        margin-bottom: 30px;

        .paper {
            flex-grow: 1;
            background: #FFFFFF;
            border-radius: 12px;
            padding: 30px;

            .paper-info {
                margin-top: 10px;
                display: flex;
                justify-content: center;

                div {
                    margin-left: 160px;
                }

                div:first-child {
                    margin-left: 0;
                }
            }

            .answer-box {
                ::v-deep img {
                    max-width: 200px;
                }
                .spin-title {
                    background: #F4F5F6;
                    padding-left: 30px;
                    padding-top: 10px;
                    padding-bottom: 10px;
                    line-height: 1.5;
                    margin-top: 21px;
                }

                .topics {
                    margin-top: 32px;
                    margin-left: 51px;
                    margin-right: 31px;

                    .topicItem {
                        margin-bottom: 20px;

                        .options {
                            width: 30px;
                            height: 30px;
                            border-radius: 50%;
                            background: #FFFFFF;
                            border: 1px solid #E5E8EC;
                            margin-right: 10px;
                        }

                        .singleActive {
                            background-color: #256CF4;
                            color: white;
                        }

                        .makeRightStyle {
                            background-color: #00B37C;
                            color: white;
                        }

                        .isErrorActive {
                            background-color: #F7593B;
                            color: white;
                        }

                        .multiple {
                            border-radius: 6px;
                        }
                    }
                }

                .multiSelect .topics {
                    .makeRightStyle {
                        background-color: #00B37C;
                        color: white;
                        border: 1px #F7593B solid;
                    }

                    .singleActive.makeRightStyle {
                        background-color: #00B37C;
                        color: white;
                        border: 1px #00B37C solid;;
                    }
                }

                .mt-60 {
                    margin-top: 60px;
                }
                .parsingBox {
                    width: 100%;
                    border-radius: 8px;
                    border: 1px solid #E5E8EC;
                    min-height: 100px;
                    padding: 30px;
                    box-sizing: border-box;
                    font-size: 14px;

                    .showAnswerText {
                        .lfet {
                            .your {
                                margin-left: 70px;
                            }
                        }
                    }

                    .parsing {
                        .tit {
                            margin: 30px 0 20px 0;

                            .cyc {
                                width: 5px;
                                height: 5px;
                                border-radius: 50%;
                                background: #256CF4;
                                margin-right: 8px;
                            }
                        }
                    }
                }

                .notParsingBox {
                    width: 100%;
                    border-radius: 8px;
                    // min-height: 218px;
                }

                .fillBlank {

                    .fillBlankItem {
                        margin-left: 51px;
                        margin-right: 31px;

                        .fillBlanktext {
                            margin: 30px 0 20px 0;
                        }

                        ::v-deep .el-textarea__inner {
                            min-height: 100px !important;
                        }
                    }

                    .confrimBtn {
                        width: 120px;
                        height: 40px;
                        background: #EEF4FF;
                        border-radius: 8px;
                        border: 1px solid #256CF4;
                        color: #256CF4;
                        margin: 40px 0;
                    }
                }
            }
        }

        .answer-card {
            position: sticky;
            top: 30px;
            left: 0;
            width: 320px;
            height: calc(100vh - 60px); // headler70px + 上下边距共60px = 130px
            background: #FFFFFF;
            border-radius: 12px;
            margin-right: 30px;

            .achievement {
                padding: 24px 21px 30px;
                width: 100%;
                box-sizing: border-box;
                .ball {
                    position: relative;
                    width: 110px;
                    height: 110px;
                    border-radius: 50%;
                    background: rgba(37,108,244,0.07);
                    margin: 30px auto;
                    .in-ball {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        border-radius: 50%;
                        width: 80px;
                        height: 80px;
                        background: #256CF4;
                        opacity: 0.2;
                        filter: blur(10px);
                    }
                    .score {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        display: flex;
                        align-items: baseline;

                        span {
                            color: #F7593B;
                            font-size: 44px;
                            font-weight: bold;
                        }
                    }
                }
            }

            .title {
                font-family: PingFangSC-Medium, PingFang SC;
                line-height: 18px;
                padding-left: 4px;
                font-size: 16px;
                border-left: 4px solid #256CF4;
            }

            .user-info {
                box-sizing: border-box;
                width: 100%;
                padding: 24px 21px 30px;
                border-bottom: 1px solid #F1F2F6;

                .info-item {
                    margin-top: 20px;

                    label {
                        width: 70px;
                        font-size: 16px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #72777F;
                        line-height: 22px;
                    }
                }
            }

            .card-title {
                box-sizing: border-box;
                padding: 23px 19px 2px 24px;

                .ans-color {
                    margin-top: 13px;

                    div {
                        margin-left: 30px;
                    }

                    div:first-child {
                        margin-left: 0
                    }

                    span {
                        width: 10px;
                        height: 10px;
                        border-radius: 2px;
                        background: #F33737;
                        display: inline-block;
                        margin-right: 4px;
                    }
                }
            }

            .submit {
                box-sizing: border-box;
                width: 100%;
                box-shadow: 0px 2px 20px 0px rgba(229, 232, 236, 0.65);
                padding: 15px 20px;

                a {
                    display: contents;
                }

                button {
                    border: unset;
                    background: #256CF4;
                    border-radius: 8px;
                    width: 100%;
                    height: 40px;
                    color: white;
                    cursor: pointer;
                }

                button:active {
                    opacity: 0.8;
                }
            }

            .ans-list {
                overflow-y: auto;
                width: 100%;
                padding-bottom: 20px;
                box-sizing: border-box;
                .snap-title {
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    line-height: 20px;
                    margin: 20px;
                }

                .ans-grid {
                    justify-content: center;
                    display: grid;
                    grid-template-columns: repeat(5, 1fr);
                    gap: 20px;
                    padding: 0 19px;
                    justify-items: center;

                    .ans-item {
                        width: 100%;
                        height: 0;
                        position: relative;
                        background: #FFFFFF;
                        padding-bottom: 100%;
                        border-radius: 8px;
                        border: 1px solid #E5E8EC;
                        font-size: 16px;
                        color: #868EA1;

                        &.has-ans {
                            background: #256CF4;
                            border: 1px solid #256CF4;
                            color: white;
                        }

                        &.right {
                            background: rgb(0, 179, 124);
                            border: 1px solid rgb(0, 179, 124);
                            color: white;
                        }

                        &.error {
                            background: #F33737;
                            border: 1px solid #F33737;
                            color: white;
                        }

                        div {
                            position: absolute;
                            left: 0;
                            top: 0;
                            width: 100%;
                            height: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }
                    }

                    .ans-item.right {
                        background: #00B37C;
                        border: 1px solid #00B37C;
                        color: white;
                    }

                    .ans-item.error {
                        background: #F7593B;
                        border: 1px solid #F7593B;
                        color: white;
                    }
                }

                &::-webkit-scrollbar {
                    width: 6px;
                }

                &::-webkit-scrollbar-track {
                    border-radius: 6px;
                }

                &::-webkit-scrollbar-thumb {
                    border-radius: 6px;
                    background: #BAC0CA;
                }
            }
        }
    }

    ::v-deep .score-dialog {
        .score {
            color: red;
        }
    }
}

</style>
